import { useEffect, useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';

import '../CommentSummaryPopover.css';

import { getCommentMessages } from '../../../ViewAndDo/Messages/api';
import {
  mentionDisplayStylePop,
  mentionStyle,
} from '../../../ViewAndDo/Messages/mentionStyle';
import { ContentWrapper } from '../ContentWrapper';
import { LoadingState } from '../LoadingState';

export const LatestCommentPopover = ({ patientInfo, goToMessageFeed }) => {
  const [latestComment, setLatestComment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchLatestComment = async () => {
      setIsLoading(true);
      try {
        const comments = await getCommentMessages(
          patientInfo.entityid,
          patientInfo.admissionid
        );
        const comment = comments.length > 0 ? comments[0] : null; // Get the latest comment or null if none
        setLatestComment(comment);
      } catch (error) {
        console.error('Error fetching comments:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLatestComment();
  }, [patientInfo.entityid, patientInfo.admissionid]);

  const handleQuickLinkClick = (event) => {
    event.preventDefault();
    goToMessageFeed(patientInfo);
  };

  const renderComment = () => (
    <ContentWrapper
      handleLinkClick={handleQuickLinkClick}
      title='Latest Comment'
      linkText='Go to Message Feed'
    >
      {/* Display originator and timestamp */}
      <p className='author'>{latestComment?.originator}</p>
      <p className='font-bold'>{latestComment?.timestamp}</p>

      {/* Display message input with mentions */}
      <MentionsInput
        disabled
        value={latestComment?.message || ''}
        style={mentionDisplayStylePop}
      >
        <Mention
          data={[]}
          displayTransform={(id, display) => `${display}`}
          markup='@[__display__](__id__)'
          trigger='@'
          style={mentionStyle}
        />
      </MentionsInput>
    </ContentWrapper>
  );

  if (isLoading)
    return (
      <LoadingState
        title='Latest Comment'
        buttonText='Go to Message Feed'
        onClick={handleQuickLinkClick}
      />
    );

  return latestComment ? renderComment() : null;
};
